@if (count()) {
  <div class="avatar-circle counter-badge">
    <span class="counter-text">{{ count() }}</span>
  </div>
} @else {
  <ion-avatar class="avatar-circle" [ngClass]="{ 'counter-text': count() }">
    <span class="avatar-initials">{{ alias() | userInitials }}</span>
  </ion-avatar>
}
